module.exports = __webpack_public_path__ + "media/images/gift-thanks-modal-bg-steak-e6eb7aa7bfa45db04a3c6c9766000be9.png";